import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function InformationalModal({
  isOpen,
  title,
  message,
  onCancel
}) {

  message = message.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  return (
    <Modal backdrop="static" keyboard={false} isOpen={isOpen} toggle={onCancel}>
      <ModalHeader
        toggle={onCancel}
        close={
          <FontAwesomeIcon
            data-testid="close-button"
            color="black"
            icon="times"
            size="2x"
            onClick={onCancel}
          />
        }
      >
        {title}
      </ModalHeader>
      <ModalBody>{message}</ModalBody>
    </Modal>
  );
};

export default InformationalModal;